import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import BulkCollection from './components/BulkCollection';
import BulkCollectionV1 from './components/BulkCollectionV1';
import PreviewCollections from './components/PreviewCollections';
import PreviewRawCollections from './components/PreviewRawCollections';
import AddRawCollection from './components/AddRawCollection';
import { isAuthenticated } from './services/tokenStorage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import ProRataCollection from './components/ProRataCollection';
import LandingPage from './components/LandingPage';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <div className="App">
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/bulk-collection" 
            element={
              <ProtectedRoute>
                <BulkCollection />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/bulk-collection-v1" 
            element={
              <ProtectedRoute>
                <BulkCollectionV1 />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/add-raw-collection" 
            element={
              <ProtectedRoute>
                <AddRawCollection />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/preview-collections" 
            element={
              <ProtectedRoute>
                <PreviewCollections />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/preview-raw-collections" 
            element={
              <ProtectedRoute>
                <PreviewRawCollections />
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/pro-rata-collection" 
            element={
              <ProtectedRoute>
                <ProRataCollection />
              </ProtectedRoute>
            } 
          />
          
          {/* Public landing page at root */}
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
